module.exports = __webpack_public_path__ + "img/payment-icon.cd21dee5.svg";